'use client';

import { CustomerType } from '@energy-retailer/constants';
import { type Dispatch, type SetStateAction, useEffect } from 'react';

import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { BaseModalContent, Modal } from '@/components/modal';
import { ANALYTICS_EVENTS } from '@/constants';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

import { Button } from '../button';

type AddressNotFoundModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
};

export const AddressNotFoundModal = ({
  isModalOpen = false,
  setIsModalOpen,
}: AddressNotFoundModalProps) => {
  const { setCustomerType, resetJoinFormStore } = useJoinFormStore();

  function cancelModal() {
    resetJoinFormStore();
    setIsModalOpen(false);
  }

  function openModal() {
    setIsModalOpen(true);
  }

  function closeModal() {
    setIsModalOpen(false);
  }

  useEffect(() => {
    if (isModalOpen) {
      trackAnalyticsEvent(ANALYTICS_EVENTS.addressNotFoundModal.modalOpen, {});
    }
  }, [isModalOpen]);

  return (
    <Modal
      heading="Please select Residential or Business address"
      description="We were unable to find your address meter details but you can still sign up by letting us know if you are signing up a Business or Residential address"
      isModalOpen={isModalOpen}
      closeModal={cancelModal}
      openModal={openModal}
    >
      <BaseModalContent
        buttonComponent={
          <>
            <Button
              iconPosition="left"
              variant="primary"
              onClick={() => {
                setCustomerType(CustomerType.Residential);

                trackAnalyticsEvent(
                  ANALYTICS_EVENTS.addressNotFoundModal.userTypeSelected
                );

                closeModal();
              }}
            >
              Residential Address
            </Button>
            <Button
              iconPosition="left"
              variant="primary"
              onClick={() => {
                setCustomerType(CustomerType.Business);

                trackAnalyticsEvent(
                  ANALYTICS_EVENTS.addressNotFoundModal.userTypeSelected
                );

                closeModal();
              }}
            >
              Business Address
            </Button>
          </>
        }
      />
    </Modal>
  );
};
